import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { StudentReport } from "../components/StudentReport";

export default function TeacherStudentDetail() {
  const { classId, studentId } = useParams();
  const [student, setStudent] = useState(null);
  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid="teacher-student-detail">
      <div className="max-w-4xl mx-auto px-5 py-8 space-y-4">
        <Link to="/ogretmen" className="text-sm text-[#007BFF] hover:underline" data-testid="teacher-student-back">← Öğretmen paneli</Link>
        <div>
          <h1 className="font-display text-3xl tracking-tight text-[#0B1A35]" data-testid="teacher-student-name">{student?.name || "Öğrenci"}</h1>
          {student && <p className="text-xs text-slate-500 mt-1">{student.email} · yalnızca sınıfa katıldığı {new Date(student.joined_at).toLocaleDateString("tr-TR")} tarihinden sonraki çözümler</p>}
        </div>
        <StudentReport url={`/teacher/classes/${classId}/analytics/students/${studentId}/report`} onLoaded={(d) => setStudent(d.student)} />
      </div>
    </div>
  );
}
